/**
 * 
 * @param {*} el 
 * @param {*} selector 
 * @param {*} event 
 * @param {*} handler 
 */
exports.delegate = (el, selector, event, handler) => {
  el.addEventListener(event, e => {
    if (e.target.matches(selector)) handler(e, el);
  });
};